import Validation from '../../common/assets/js/validation';
import Time from '../../common/modules/time/time';

export default class CartBindings {
    constructor() {
        this.submitCart = '.js-cartSubmit';
        this.legalEntityCheckbox = '.js-legalEntity';
        this.companyName = '.js-companyNameLine';
        this.companyUnp = '.js-unp';
        this.plus = '._js-plus';
        this.minus = '._js-minus';
        this.itemPrice = '._js-common-price';
        this.prodCount = '._js-prod-count';
        this.totalPrice = '.js-cartTotalPrice';
        this.deleteItem = '._js-cart-item-del';
        this.recoveryItem = '._js-recovery';
        this.calendarConfirm = '._js-calendar-confirm';

        this.bindEvents();
    }

    bindEvents() {
        $(document)
            .on('click', this.submitCart, (e) => {
                let $form = $(e.target).closest('.cart-contact'),
                    cartItems = $('.cart-item'),
                    isAllItemsDeleted = true;

                //validate the form
                if (!Validation.isFormValid($form)) {
                    e.preventDefault();
                }

                //check is all items in the cart are deleted
                for (let i = 0; i < cartItems.length; i++) {
                    let currentItem = $(cartItems[i]);  

                    if (!currentItem.hasClass('_deleted')) {
                        isAllItemsDeleted = false;
                    }
                }
                //show error cart msg if there in no items in the cart, and scroll to the top of the page
                if (isAllItemsDeleted) {
                    e.preventDefault();
                    $('.cart-error').removeClass('_hidden');
                    $('html, body').animate({ scrollTop: 0 }, 'slow');
                }
            })
            .on('click', this.legalEntityCheckbox, (e) => {
                let isChecked = $(e.target).is(':checked');

                this.toggleCompanyNameField(isChecked);
            })
            .on('input', `.product-offers ${this.prodCount}`, (e) => {
                let $target = $(e.target),
                    maxValue = parseInt($target.closest('.product-offers__description_quantity').find('._js-prod-count').attr('data-max-value')),
                    $productRow = $target.closest('.product-offers__owner'),
                    $itemsAvailableText = $productRow.find('.product-offers__availabe'),
                    $rentBtn = $productRow.find('.add-to-cart'),
                    currentValue = parseInt($productRow.find('.text-field-prod_quantity').val());

                /*show/hide tooltip if selected currentValue more than maxValue*/
                if (currentValue > maxValue ) {
                    $itemsAvailableText.addClass('_error');
                    $rentBtn.addClass('_disabled');
                    return false;
                } else {
                    $itemsAvailableText.removeClass('_error');
                    $rentBtn.removeClass('_disabled');
                }

            })
            .on('blur', 'input[required]', (e) => {
                Validation.validateInput(e.target);
            })
            .on('focus', '.text-field-prod_quantity', (e) => {
                $(e.target).parents('.product-offers__owner').find('.tooltip').hide();
            })
            .on('click', this.plus, (e) => {
                let $target = $(e.target),
                    $cartItem = $target.closest('.cart-item'),
                    $count = $cartItem.find('._js-prod-count'),
                    currentCount = parseInt($count.val().length ? $count.val() : 0),
                    maxValue = parseInt($(e.target).closest('.cart-item').find(this.prodCount).attr('data-max-value')),
                    $tooltip = $(e.target).closest('.cart-item__inner-block').find('.tooltip');

                //if input is empty dont do any
                if (currentCount == 0) {
                    return false;
                }

                /*show/hide tooltip if selected currentValue more than maxValue*/
                if (currentCount >= maxValue ) {
                    $tooltip.show();
                    return false;
                } else {
                    $tooltip.hide();
                }

                $count.val(++currentCount);
                this.calculateProductPrice($cartItem);
                this.updateTotalPrice();
            })
            .on('focus', this.prodCount, (e) => {
                $(e.target).closest('.cart-item__inner-block').find('.tooltip').hide();
            })
            .on('click', this.minus, (e) => {
                let $target = $(e.target),
                    $cartItem = $target.closest('.cart-item'),
                    $count = $cartItem.find('._js-prod-count'),
                    currentCount = parseInt($count.val()),
                    maxValue = parseInt($(e.target).closest('.cart-item').find('._js-prod-count').attr('data-max-value')),
                    $tooltip = $(e.target).closest('.cart-item__inner-block').find('.tooltip');

                if (currentCount <= maxValue ) {
                    $tooltip.hide();
                }

                if (currentCount > 1) {
                    $count.val(--currentCount);
                }
                this.calculateProductPrice($cartItem);
                this.updateTotalPrice();
            })
            //validate max avaliable amount on value change
            .on('change blur', this.prodCount, (e) => {
                let $field = $(e.target),
                    $cartItem = $field.closest('.cart-item'),
                    $count = $cartItem.find('._js-prod-count'),
                    currentCount = parseInt($count.val()),
                    maxValue = parseInt(($field).attr('data-max-value')),
                    $tooltip = $(e.target).closest('.cart-item__inner-block').find('.tooltip');

                /*show/hide tooltip if selected currentValue more than maxValue*/
                if (currentCount > maxValue ) {
                    $('.order-error-tooltip').hide();
                    $tooltip.show();
                    return false;
                } else {
                    $tooltip.hide();
                }

                $('.order-error-tooltip').hide();
                this.calculateProductPrice($cartItem);
                this.updateTotalPrice();
            })
            .on('click', this.deleteItem, (e) => {
                let $target = $(e.target),
                    $product = $target.closest('.cart-item'),
                    $removedProduct = $product.next(),
                    $mobileCartCount = $('.js-mobile-cart-count');

                $mobileCartCount.text(parseInt($mobileCartCount.text()) - 1);

                $.request('Cart::onRemove', {
                    loading: '.js-preloaderOverlay',
                    data: {
                        cart: [
                            $($target).parents('.cart-item').attr('data-offer-id')
                        ]
                    },
                    update: {
                        'jade-cart-button': '.cart-button-wrapper',
                        'cart-offer-count': '._cart-offer-count-text'
                    },
                    complete: (response) => {

                        let obResult = response.responseJSON;
                        
                        $product.slideToggle();
                        $product.addClass('_deleted');
                        Time.deleteTimeInput($product);
                        $removedProduct.slideToggle();
                        this.updateTotalPrice();


                        $product.find('.tooltip').hide();
                    }
                });
            })
            .on('data-attribute-changed', this.calendarConfirm, (e) => {
                let $field = $(e.target);
                let $cartItem = $field.closest('.cart-item');
                let _this = this;
                if ($('.page-cart .cart-item').length) {
                    _this.calculateProductPrice($cartItem);
                    _this.updateTotalPrice();
                }
            })
            .on('click', this.recoveryItem, (e) => {
                let $target = $(e.target),
                    $removedProduct = $target.closest('.cart-item-removed'),
                    $product = $removedProduct.prev(),
                    iOfferID = $target.attr('data-offer-id'),
                    $cartItem = $('.cart-item[data-offer-id="' + iOfferID + '"]'),
                    $cartError = $target.closest('.inner-wrapper').find('.cart-error'),
                    $mobileCartCount = $('.js-mobile-cart-count');

                $mobileCartCount.text(parseInt($mobileCartCount.text()) + 1);
                $cartError.addClass('_hidden');
                $.request('Cart::onAdd', {
                    loading: '.js-preloaderOverlay',
                    data: {
                        cart: [{
                            'offer_id': iOfferID,
                            'quantity': $cartItem.find('.text-field-prod_quantity').val(),
                            'date_start': $cartItem.find('.calendar-details__summary_cart').attr('data-date'),
                            'period': $cartItem.find('.calendar-details__summary_cart').attr('data-period')
                        }]
                    },
                    update: {
                        'jade-cart-button': '.cart-button-wrapper',
                        'cart-offer-count': '._cart-offer-count-text'
                    },
                    complete: (response) => {

                        let obResult = response.responseJSON;
                        $removedProduct.slideToggle();
                        $product.removeClass('_deleted');
                        $product.slideToggle();
                        this.updateTotalPrice();

                        Time.appendSelectedTimeToForm($product);

                        $target.closest('.cart-item__inner-block').find('.tooltip').hide();
                    }
                });
            });
    }

    /**
     * sum prices of all items in the cart, and update total price
     */
    updateTotalPrice() {
        let $totalPriceElemArr = $(this.totalPrice),
            $itemPriceArr = $('.cart-item:not(._deleted)').find(this.itemPrice),
            totalPrice = 0;
        //sum prices for each item in cart to totalPrice
        for (let i = 0; i < $itemPriceArr.length; i++) {
            let currentItemPrice = parseFloat($($itemPriceArr[i]).text().replace(',', '.').replace(' ', '').replace(' ', '').replace(/\u00A0/g, ''));

            totalPrice = totalPrice + currentItemPrice;
        }
        //convert total price to xx,xx format
        totalPrice = totalPrice.toLocaleString('ru', {minimumFractionDigits: 2, maximumFractionDigits: 2});

        //fill total price
        for (let j = 0; j < $totalPriceElemArr.length; j++) {
            $($totalPriceElemArr[j]).val(totalPrice);
        }
    }

    /**
     *  show/hide company name field
     * @param isSeen
     */
    toggleCompanyNameField(isSeen) {
        let companyNameItem = $(this.companyName),
            companyUnpItem = $(this.companyUnp),
            companyNameInput = companyNameItem.find('input'),
            companyUnpInput = companyUnpItem.find('input');

        if (isSeen) {
            companyNameItem.removeClass('_hidden');
            companyUnpItem.removeClass('_hidden');
            companyNameInput.prop('disabled', false);
            companyUnpInput.prop('disabled', false);
        } else {
            companyNameItem.addClass('_hidden');
            companyUnpItem.addClass('_hidden');
            companyNameInput.prop('disabled', true);
            companyUnpInput.prop('disabled', true);
            companyNameInput.removeClass('_error');
            companyUnpInput.removeClass('_error');
        }
    }

    calculateProductPrice($cartItem) {
        let priceProduct = Number($cartItem.find('._js-cart-price').text().replace(',', '.').replace(' ', '').replace(' ', '').replace(/\u00A0/g, '')),
            countOfProd = Number($cartItem.find('._js-prod-count').val()),
            datePeriod = parseInt($cartItem.find('.js-period').attr('data-period'));

        datePeriod = datePeriod ? datePeriod : 1;
        $cartItem.find('._js-common-price').text((priceProduct * countOfProd * datePeriod).toLocaleString('ru', {minimumFractionDigits: 2, maximumFractionDigits: 2}));

        $.request('Cart::onUpdate', {
            data: {
                cart: [
                    {
                        'offer_id': $cartItem.attr('data-offer-id'),
                        'quantity': countOfProd,
                        'date_start': $cartItem.attr('data-offer-start'),
                        'period': $cartItem.attr('data-offer-period')
                    }
                ],
                rewrite: true
            }
        });
    }

}


// WEBPACK FOOTER //
// ./src/pages/cart/CartBindings.js